import React from "react";
import ModalCard from "../../../components/ModalCard";
import { Box, Button, Stack, Typography } from "@mui/material";
import {
  BGColor02,
  blackColor,
  blueColor04,
  mobilePrimary,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import FilePickerInput from "../../../components/Input/FilePickerInput";

function ImageEditPopup({
  openModal,
  setOpenModal,
  value,
  onValueChange,
  onDoneClick,
  onDeletePhotos,
}) {
  return (
    <ModalCard
      open={openModal}
      handleClose={() => {
        setOpenModal(false);
      }}
      width="500px"
    >
      <Stack
        sx={{
          backgroundColor: whiteColor,
          borderRadius: "10px",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Box sx={{ backgroundColor: BGColor02, p: "15px", width: "100%" }}>
          <Typography
            variant="body1"
            fontSize={15}
            fontWeight={500}
            color={blackColor}
            textAlign={"center"}
          >
            Product Photo
          </Typography>
        </Box>

        <Box width="430px" p="15px 0 25px">
          <FilePickerInput
            required
            ratio={4 / 3}
            setCropedImage={(data) => onValueChange(data)}
            hideLabel
            onDelete={(data) => onDeletePhotos(data)}
            cropedimage={value}
            mbWidth={"100%"}
            height={"323px"}
            setLogoChange={() => {}}
          />
        </Box>

        <Stack
          alignItems="flex-end"
          sx={{ backgroundColor: BGColor02, p: "15px", width: "100%" }}
        >
          <Button
            variant="contained"
            disableElevation
            sx={styles.applyBtn}
            onClick={onDoneClick}
          >
            DONE
          </Button>
        </Stack>
      </Stack>
    </ModalCard>
  );
}

export default ImageEditPopup;

const styles = {
  applyBtn: {
    fontSize: 13,
    fontWeight: 500,
    backgroundColor: { md: blueColor04, xs: mobilePrimary },
    border: `1.5px solid ${{ md: blueColor04, xs: mobilePrimary }}`,
    color: whiteColor,
    p: "4px 30px",
    // mt: 2,
    "&:hover": {
      color: { md: blueColor04, xs: mobilePrimary },
      backgroundColor: whiteColor,
    },
  },
};
